import type { ServiceLength } from '../api/client'
import { formatLength } from '../catalog/format'

interface Props {
  lengths: ServiceLength[]
  selected: string | null
  disabled?: boolean
  // A length shown but not offered (e.g. one their package doesn't cover).
  unavailable?: (length: ServiceLength) => boolean
  onSelect: (length: ServiceLength) => void
}

// LengthPicker is the "60 min | 90 min" choice under a treatment with more
// than one length. Nothing is chosen until she picks (spec §4.3).
export default function LengthPicker({ lengths, selected, disabled, unavailable, onSelect }: Props) {
  return (
    <div className="segmented" role="group" aria-label="Length">
      {lengths.map((l) => (
        <button key={l.id} type="button" aria-pressed={selected === l.id} disabled={disabled || unavailable?.(l)} onClick={() => onSelect(l)}>
          {formatLength(l.duration_minutes)}
        </button>
      ))}
    </div>
  )
}
